var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"content",staticClass:"cursor-pointer",on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseLeave,"click":_vm.click}},[_vm._t("content")],2),(_vm.show)?_c('div',{ref:"tooltip",staticClass:"tooltip",on:{"click":_vm.click}},[_vm._t("tooltip")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }